export const AUDIO_MUTE = 'AUDIO_MUTE';

export const CREATE_CONNECTION = 'CREATE_CONNECTION';

export const DIAL_OUT = 'DIAL_OUT';

export const DESTROY_CONNECTION = 'DESTROY_CONNECTION';

export const JOIN_AD_HOC_MEETING = 'JOIN_AD_HOC_MEETING';

export const JOIN_SCHEDULED_MEETING = 'JOIN_SCHEDULED_MEETING';

export const JOIN_WITH_SCREENSHARING = 'JOIN_WITH_SCREENSHARING';

export const HANG_UP = 'HANG_UP';

export const PASSWORD = 'PASSWORD';

export const RECONNECTION_SCHEDULE_UPDATED = 'RECONNECTION_SCHEDULE_UPDATED';

export const REMOTE_CONTROL_UPDATE_SCREENSHARE_STATE = 'REMOTE_CONTROL_UPDATE_SCREENSHARE_STATE';

export const SCREENSHARE = 'SCREENSHARE';

export const TILE_VIEW = 'TILE_VIEW';

export const VIDEO_MUTE = 'VIDEO_MUTE';
